// @UI
import { Box } from '@chakra-ui/react'

interface IProps {
  played: number
  isControlsVisible: boolean
}

export const ProgressBarOverlay = ({ played, isControlsVisible }: IProps) => (
  <Box
    bg='rgba(255,255,255,0.15)'
    bottom={0}
    h='3px'
    left={0}
    opacity={isControlsVisible ? 0 : 1}
    pointerEvents='none'
    position='absolute'
    transition='opacity 0.2s'
    w='full'
    zIndex={1}
  >
    <Box
      bg='incident.active.100'
      h='full'
      transition='width 0.2s linear'
      w={`${played * 100}%`}
    />
  </Box>
)
